<template>
  <div>
    <q-list
      v-if="order.deliveryType !== DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER && order.deliveryType !== DELIVERY_TYPE_OPTIONS.VIRTUAL"
      :bordered="!rounded || !spacing"
      separator
      :class="$register ? undefined : 'bg-responsive q-mt-sm'"
      data-test-id="delivery-information-list"
      @click="showOrderOptions = true"
    >
      <slot name="header" />
      <q-item
        v-if="!$register && headerShowAvatar"
        :class="{
          [`bg-${headerBgColor}`]: !$_.isNil(headerBgColor) && !$_.isEmpty(headerBgColor),
          [$getTextColor(currentSite, headerBgColor)]: !$_.isNil(headerBgColor) && !$_.isEmpty(headerBgColor),
          'text-responsive bg-responsive-grey-3 border-top border-left border-right': $_.isNil(headerBgColor) || $_.isEmpty(headerBgColor),
          'rounded-borders-8': rounded,
          'q-mb-sm': spacing
        }"
        dense
      >
        <q-item-section avatar>
          <q-avatar
            icon="fal fa-popcorn"
            :text-color="{
              [$getTextColor(currentSite, headerBgColor)]: !$_.isNil(headerBgColor) && !$_.isEmpty(headerBgColor),
              'text-responsive': $_.isNil(headerBgColor) || $_.isEmpty(headerBgColor)
            }"
          />
        </q-item-section>
        <slot name="title" />

        <q-item-section
          side
        >
          <q-item-label
            caption
            class="cursor-pointer"
            :class="{
              [$getTextColor(currentSite, headerBgColor)]: !$_.isNil(headerBgColor) && !$_.isEmpty(headerBgColor),
              'text-responsive': $_.isNil(headerBgColor) || $_.isEmpty(headerBgColor)
            }"
          >
            {{ $t('actions.edit') }}
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        class="cursor-pointer"
        :class="{
          'rounded-borders-8': rounded,
          'q-mb-sm': spacing,
          'borders': bordered
        }"
      >
        <q-item-section>
          <q-item-label
            class="text-capitalize text-weight-bold"
          >
            {{ $_.startCase(order.deliveryTypeName) }}
          </q-item-label>
        </q-item-section>
        <q-item-section v-if="$_.includes(DELIVERY_TYPE_OPTIONS.DELIVERY_LOCATION_REQUIRED, order.deliveryType)">
          <q-item-label
            class="text-center"
          >
            {{ order.deliveryLocation }}
          </q-item-label>
        </q-item-section>
        <q-item-section v-if="order.customDeliveryType && order.deliveryDetails">
          <q-item-label
            overline
            class="text-center ellipsis"
            style="max-width: 200px;"
          >
            {{ order.deliveryDetails }}
          </q-item-label>
        </q-item-section>
        <q-item-section v-if="order.pagerNumber">
          <q-item-label
            v-if="order.pagerNumber"
            overline
            class="text-center"
          >
            Pager #{{ order.pagerNumber }}
          </q-item-label>
        </q-item-section>
        <q-item-section v-if="order.nameForOrder">
          <q-item-label
            v-if="order.nameForOrder"
            overline
            class="text-center"
          >
            {{ order.nameForOrder }}
          </q-item-label>
        </q-item-section>
        <q-item-section
          class="text-right"
        >
          {{ order.hasDueTime ? order.formattedDueTime : 'ASAP' }}
        </q-item-section>
      </q-item>
    </q-list>
    <order-options-dialog
      v-model="showOrderOptions"
      :order="order"
      show-timing
      :order-can-transfer-tab="order.canTransferTab"
      :rounded="rounded"
      :bordered="bordered"
      @update:model-value="value => showOrderOptions = value"
    />
  </div>
</template>

<script>
import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import OrderOptionsDialog from 'src/modules/register/dialogs/OrderOptionsDialog'
export default {
  name: 'DeliveryInformationList',
  components: {
    OrderOptionsDialog
  },
  configuration: ['currentSite'],
  props: {
    order: {
      type: Object,
      required: true
    },
    headerBgColor: {
      type: String,
      required: false,
      default: null
    },
    headerShowAvatar: {
      type: Boolean,
      required: false,
      default: false
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false
    },
    spacing: {
      type: Boolean,
      required: false,
      default: false
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showOrderOptions: false
    }
  },
  created () {
    _.extend(this, { DELIVERY_TYPE_OPTIONS })
  }
}

</script>
